import React from 'react'
import AboutHeroSection from './AboutHeroSection'
import AboutSecondSection from './AboutSecondSection'
import AboutStatsSection from './AboutStatsSection'

const AboutUsPage = () => {
  return (
    <div>
        <AboutHeroSection/>
        <AboutSecondSection/>
        <AboutStatsSection/>
    </div>
  )
}

export default AboutUsPage